import cookie from 'react-cookies';
import env from '@/env';

const COOKIE_DOMAIN = env.cookie.domain;

const COOKIE_REFRESH_TOKEN = 'refreshToken';
const COOKIE_ID_TOKEN = 'id_token';
const SESSIONSTORAGE_ACCESS_TOKEN = 'access_token';
const SOCIAL_ACCESS_TOKEN = 'socialUser';
const LINKEDIN_CALLBACK = 'linkedin_callback';
const ASSET_HISTORY = 'asset_history';
const ORGANISATION_TOKEN = 'org-token';
const NEED_VERIFICATION = 'Secure';
const SESSION_VERIFICATION = 'SSSecure';

const setCookie = (name: string, value: string, httpOnly?: boolean) =>
  cookie.save(name, value, { path: '/', domain: COOKIE_DOMAIN, httpOnly });

const getCookie = (name: string) => cookie.load(name);

const removeCookie = (name: string) => cookie.remove(name, { path: '/', domain: COOKIE_DOMAIN });

class AuthHelpers {
  storeIdToken = (idToken: string) => setCookie(COOKIE_ID_TOKEN, idToken);

  getIdToken = () => getCookie(COOKIE_ID_TOKEN);

  storeRefreshToken = (refreshToken: string) => setCookie(COOKIE_REFRESH_TOKEN, refreshToken);

  getRefreshToken = () => getCookie(COOKIE_REFRESH_TOKEN);

  getAccessToken = () => getCookie(SESSIONSTORAGE_ACCESS_TOKEN);

  storeAccessToken = (accessToken: string) => setCookie(SESSIONSTORAGE_ACCESS_TOKEN, accessToken);

  clearAccessToken = () => removeCookie(SESSIONSTORAGE_ACCESS_TOKEN);

  clearTokens = () => {
    removeCookie(COOKIE_REFRESH_TOKEN);
    removeCookie(COOKIE_ID_TOKEN);
    removeCookie(ORGANISATION_TOKEN);
    removeCookie(SESSIONSTORAGE_ACCESS_TOKEN);
    sessionStorage.clear();
  };

  storeSocialToken = (socialToken: string) => setCookie(SOCIAL_ACCESS_TOKEN, socialToken);

  getSocialToken = () => getCookie(SOCIAL_ACCESS_TOKEN);

  clearSocialToken = () => removeCookie(SOCIAL_ACCESS_TOKEN);

  storeAssetHistory = (assetHistory: string) => setCookie(ASSET_HISTORY, assetHistory);

  getAssetHistory = () => getCookie(ASSET_HISTORY);

  clearAssetHistory = () => {
    removeCookie(ASSET_HISTORY);
  };

  storeLinkedInCallback = (linkedinCB: string) => setCookie(LINKEDIN_CALLBACK, linkedinCB);

  getLinkedInCallback = () => getCookie(LINKEDIN_CALLBACK);

  getOrgToken = () => getCookie(ORGANISATION_TOKEN);

  storeOrgToken = (orgToken: string) => setCookie(ORGANISATION_TOKEN, orgToken);

  clearLinkedInCallback = () => {
    removeCookie(LINKEDIN_CALLBACK);
  };

  getNeedVerification = () => getCookie(NEED_VERIFICATION);

  needVerification = () => setCookie(NEED_VERIFICATION, btoa('true'));

  clearNeedVerification = () => {
    removeCookie(NEED_VERIFICATION);
  };

  getSessionVerification = () => getCookie(SESSION_VERIFICATION);

  setSessionVerification = () => setCookie(SESSION_VERIFICATION, btoa('true'));

  clearSessionVerification = () => setCookie(SESSION_VERIFICATION, btoa('false'));
}

const instance = new AuthHelpers();
export default instance;
